import React, {
  useCallback,
  useMemo,
  useState,
} from "react";

import useRiskFinancingEngine
  from "../hooks/useRiskFinancingEngine";

import RiskFinancingContext
  from "./RiskFinancingContext";

export default function RiskFinancingProvider({
  children,

  settingsLoaded,
  simulations,
  strategyAnalysisEnabled = true,

  /*
   * Optional controlled tab state.
   *
   * When these props are omitted, the
   * Provider manages its own internal tab.
   */
  activeTab: providedActiveTab,
  onTabChange: providedOnTabChange,

  initialTab = "portfolio",
}) {
  const [
    internalActiveTab,
    setInternalActiveTab,
  ] = useState(initialTab);

  const activeTab =
    providedActiveTab ??
    internalActiveTab;

  const handleTabChange =
    useCallback(
      (nextTab) => {
        if (providedOnTabChange) {
          providedOnTabChange(nextTab);
          return;
        }

        setInternalActiveTab(nextTab);
      },
      [providedOnTabChange]
    );

  const engine =
    useRiskFinancingEngine({
      activeTab,
      settingsLoaded,
      simulations,
      strategyAnalysisEnabled,
      onTabChange:
        handleTabChange,
    });

  /*
   * Publish both the engine and the tab
   * controller through the same context.
   */
  const contextValue =
    useMemo(
      () => ({
        ...engine,

        navigation: {
          activeTab,
          setActiveTab:
            handleTabChange,
        },
      }),
      [
        engine,
        activeTab,
        handleTabChange,
      ]
    );

  return (
    <RiskFinancingContext.Provider
      value={contextValue}
    >
      {children}
    </RiskFinancingContext.Provider>
  );
}
